import { useTranslation } from 'react-i18next';
import { RWebShare } from 'react-web-share';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as LinkedInIcon } from './../../../../icons/linkedin.svg';
import { ReactComponent as ReplyIcon } from './../../../../icons/reply.svg';
import { useAccount } from '../../../../contexts/Account';
import eventBus from '../../../../eventBus';

const useStyles = (isXS) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionbuttons: {
    display: 'flex',
    flexDirection: isXS ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: 'right',
    margin: 'theme.spacing(1)',
  },
  buttons: {
    width: isXS ? '100%' : 'inherit',
    paddingRight: isXS ? '10px' : '',
    paddingLeft: isXS ? '10px' : '',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: isXS ? '12px' : '7px',
  },
  flatButton: {
    textTransform: 'none',
    color: '#232B35',
    fontFamily: 'Poppins',
  },
  linkButton: {
    textTransform: 'none',
    borderRadius: '10px',
    border: '1px solid #EFF0F7',
    overflow: 'hidden',
    // marginLeft: '5px',
    height: '35px',
    color: '#232B35',
    fontFamily: 'Poppins',
  },
});

export default function ActionBarOwnProfile(props) {
  const { t } = useTranslation();
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles(isXS);
  const { accountDetails } = useAccount();
  const publicProfileUrl = accountDetails
    ? accountDetails.publicProfileUrl
    : '';
  const { publicProfileFlag, setSuccessMessage, setSuccessSnackbar } = props;
  const publicProfile = publicProfileFlag
    ? `https://${process.env.REACT_APP_PUBLIC_PROFILES_URL}/${publicProfileUrl}`
    : `advisorycloud.com/profile/${publicProfileUrl}`;

  function copyToClipboard() {
    navigator.clipboard.writeText(publicProfile);
    setSuccessMessage(t('PROFILE-CLIPBOARD-MESSAGE'));
    setSuccessSnackbar(true);
  }

  return (
    <div style={classes.root}>
      <div style={classes.buttons}>
        <div style={classes.actionbuttons} id="actionbuttonsContainer">
          <Typography
            sx={{
              fontWeight: '700',
              fontSize: '12px',
              lineHeight: '150%',
              letterSpacing: '0%',
              color: '#4D586F',
              marginTop: '8px',
              marginRight: '8px',
            }}
          >
            Advisor Profile URL:
          </Typography>
          <Button
            variant="outlined"
            sx={classes.linkButton}
            onClick={copyToClipboard}
          >
            {publicProfile}
          </Button>
          {!isXS ? (
            <>
              <RWebShare
                data={{
                  text: `${t('ADVISOR-LINKEDIN-POST-TEXT')}`,
                  url: publicProfile,
                  title: 'Share your advisor profile',
                }}
                onClick={() => {
                  setSuccessMessage('Your profile is shared successfully.');
                  setSuccessSnackbar(true);
                }}
              >
                <Button
                  variant="text"
                  id="shareButton"
                  sx={classes.flatButton}
                  startIcon={<ReplyIcon />}
                >
                  Share
                </Button>
              </RWebShare>

              <Button
                variant="text"
                id="promoteButton"
                sx={classes.flatButton}
                startIcon={<LinkedInIcon />}
                onClick={() => eventBus.dispatch('openLinkedInPostModal')}
              >
                Promote
              </Button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
